function Contact() {
  return (
    <div className="container contact text-center" style={{ padding: '4rem 1rem' }}>
      <h2 className="main-title">CONTACT</h2>
      
      <p style={{ fontSize: '1.2rem', marginTop: '1.5rem', maxWidth: '700px', marginInline: 'auto' }}>
        To request an update to our product catalog or inquire about our services in fragrances,
        common kitchen items, or clothing, please reach out to us via email.
      </p>

      <div style={{
        marginTop: '2.5rem',
        backgroundColor: '#f8f9fa',
        padding: '2rem',
        borderRadius: '12px',
        boxShadow: '0 0 10px rgba(0,0,0,0.05)',
        maxWidth: '600px',
        marginInline: 'auto'
      }}>
        <h4 style={{ fontWeight: '600' }}>📧 Email</h4>
        <p>
          <a
            href="mailto:Contact@rasbsnsinc.com"
            style={{
              textDecoration: 'none',
              color: '#007bff',
              fontWeight: '500',
              fontSize: '1.1rem'
            }}
          >
            Contact@rasbsnsinc.com
          </a>
        </p>

        <h4 style={{ fontWeight: '600', marginTop: '2rem' }}>🏢 Office Address</h4>
        <p style={{ fontSize: '1rem' }}> <a style={{ textDecoration: 'none' }} href='https://maps.app.goo.gl/toPRNb5gQNt2HwJL6'>
          188-02 64th Avenue 10B<br />
          Fresh Meadows, New York 11365<br /></a>
          📞 +1 347 207 5476
        </p>
      </div>
    </div>
  );
}

export default Contact;
